<script>
import FormTextarea from "@/components/forms/FormTextarea.vue"
import FormInput from "@/components/forms/FormInput.vue"
import { useTransformationFunctionsStore } from "@/store/modules/transformationFunctions"
import UserAttributesField from "@/components/devices/userAttributesField.vue"

export default {
  name: "TransformationFunctionTesting",
  components: { UserAttributesField, FormInput, FormTextarea },
  props: {
    transformationFunction: {
      type: Object,
      required: true
    }
  },
  setup() {
    const tfStore = useTransformationFunctionsStore()
    return { tfStore }
  },
  data() {
    return {
      inputMessage: "",
      outputMessage: "",
      tags: null,
      userAttributes: {}
    }
  },
  watch: {
    "transformationFunction.transformationId": function () {
      this.inputMessage = ""
      this.outputMessage = ""
    }
  },
  methods: {
    async doTestRun() {
      const res = await this.tfStore.testRun({
        definitionType: this.transformationFunction.definitionType,
        definition: btoa(this.transformationFunction.definition),
        message: this.inputMessage,
        tags: this.tags?.split(",").map((tag) => tag.trim()) ?? [],
        attributes: this.userAttributes
      })
      this.outputMessage = res.transformMessage
    },
    handleAttributesChanged(attributes) {
      this.userAttributes = {}
      for (const attr of attributes ?? []) {
        this.userAttributes[attr.title] = attr.value
      }
    }
  }
}
</script>

<template>
  <div>
    <div class="d-flex justify-content-between gap-2 mb-2">
      <FormTextarea :value="inputMessage" @change="inputMessage = $event" :label="$t('INPUT_MESSAGE')" class="w-100" />
      <FormTextarea :label="$t('OUTPUT_MESSAGE')" :value="outputMessage" class="w-100" disabled />
    </div>
    <button class="btn btn-primary primary-shadow mb-4" @click="doTestRun">
      {{ $t("TEST") }}
    </button>
    <FormInput
      :value="tags"
      @change="tags = $event"
      :label="$t('tagy')"
      class="mb-3 w-50"
      placeholder="tag1, tag2, tag 3, ..."
    />
    <div class="font-weight-light mb-1 text-left">
      {{ $t("USER_ATTRIBUTES") }}
    </div>
    <UserAttributesField display-in-row hide-title :attributes="userAttributes" @change="handleAttributesChanged" />
  </div>
</template>
